var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{attrs:{"id":"user-online-count"}},[(_vm.count !== null)?[_vm._v(" "+_vm._s(_vm.count)+" "),_vm._t("default")]:_c('v-skeleton-loader',{attrs:{"elevation":"0","type":"text"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }